import { Injectable } from "@angular/core";
import { initializeApp, FirebaseApp } from "firebase/app";
import { getAnalytics, Analytics, logEvent } from "firebase/analytics";
import { firebaseConfig } from "../../firebase-config";
import { gaLoggerRecord } from "../utils/ga-logger";

@Injectable({ providedIn: "root" })
export class FirebaseHelper {
  private app: FirebaseApp;
  private analytics: Analytics;

  constructor() {
    this.init();
  }

  private init() {
    try {
      this.app = initializeApp(firebaseConfig);
      const w = window as any;
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push('set', { cookie_domain: window.location.hostname });
      this.analytics = getAnalytics(this.app);
      console.log("Firebase Analytics initialized successfully");
    } catch (error) {
      console.warn("Firebase config not found or failed to initialize:", error);
    }
  }

  logEvent(eventName: string, params?: any) {
    gaLoggerRecord(eventName, params);
    if (this.analytics) {
      logEvent(this.analytics, eventName, params);
    }
  }
}
